import { clearState, setLoading } from 'src/contexts/utils';
import { IStoreGroupInitialContext } from '../types';
import * as StoreGroupFunctions from '../utils';
import { DEFAULT_STORE_GROUP_STATE } from './defaultState';

export const DEFAULT_STORE_GROUP_CONTEXT: IStoreGroupInitialContext = {
    ...DEFAULT_STORE_GROUP_STATE,
    ...StoreGroupFunctions,
    clearStoreGroupState: clearState,
    setLoading,
};
